import { ShieldCheck, Mic, UserCheck, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const valueProps = [
  {
    icon: ShieldCheck,
    title: 'Eliminate Administrative Friction',
    body: 'No more chasing authorizations or correcting coding queries weeks after the case.',
  },
  {
    icon: Mic,
    title: 'Dictate Once, Sign Once',
    body: 'Our optional high-fidelity dictation captures your clinical intent and auto-reconciles it against the authorized bundle.',
  },
  {
    icon: UserCheck,
    title: 'Clinical Sovereignty',
    body: 'You remain the sole authority. LINK never "suggests" codes; it only verifies your documentation against your intent.',
  },
];

const beforeItems = ['Fragmentation', 'Denials', '3 AM Charting'];
const afterItems = ['Closed-Loop Integrity', 'Instant Reconciliation', 'Audit Safety'];

export function SurgeonSegment() {
  return (
    <div className="max-w-5xl mx-auto">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
          Focus on the Patient. We'll Handle the Proof.
        </h2>
        <p className="text-muted-foreground text-lg max-w-xl mx-auto">
          The administrative shield that lets surgeons operate, not administrate.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-14">
        {valueProps.map((prop) => (
          <Card
            key={prop.title}
            className="bg-card border border-border rounded-xl transition-all hover:shadow-lg"
          >
            <CardContent className="p-8">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 border border-primary/20 mb-5">
                <prop.icon className="h-5 w-5 text-primary" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-3">
                {prop.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {prop.body}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Before & After */}
      <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-6 md:gap-0 items-stretch max-w-3xl mx-auto">
        <div className="rounded-xl border border-destructive/20 bg-destructive/5 p-8">
          <p className="text-xs uppercase tracking-wider text-destructive font-semibold mb-4">
            Before LINK
          </p>
          <ul className="space-y-3">
            {beforeItems.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="flex items-center justify-center w-5 h-5 rounded bg-destructive/15 border border-destructive/30 mt-0.5">
                  <span className="block w-1.5 h-1.5 rounded-full bg-destructive" />
                </span>
                <span className="text-sm text-foreground font-medium">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="hidden md:flex items-center justify-center px-6">
          <div className="flex flex-col items-center gap-1">
            <ArrowRight className="h-6 w-6 text-primary" strokeWidth={1.5} />
            <span className="text-[10px] text-primary font-semibold uppercase tracking-wider">
              LINK
            </span>
          </div>
        </div>

        <div className="rounded-xl border border-primary/20 bg-primary/5 p-8">
          <p className="text-xs uppercase tracking-wider text-primary font-semibold mb-4">
            After LINK
          </p>
          <ul className="space-y-3">
            {afterItems.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="flex items-center justify-center w-5 h-5 rounded bg-primary/15 border border-primary/30 mt-0.5">
                  <span className="block w-1.5 h-1.5 rounded-full bg-primary" />
                </span>
                <span className="text-sm text-primary font-medium">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
